import { Renderer } from 'marked';
import './MarkdownExtension';

// https://marked.js.org/using_advanced#extensions
export const renderer: Partial<Renderer> = {
  heading: (text, level) => (
    `<h${level}>${text}</h${level}>`
  ),
  list: (body, isOrdered) => (
    `<${isOrdered ? 'ol' : 'ul'}
      class='${isOrdered ? 'list-decimal' : 'list-disc'}'
    >
      ${body}
    </${isOrdered ? 'ol' : 'ul'}>`
  ),
  blockquote: (quote) => (
    `<blockquote class='m-0 p-5 bg-slate-200 rounded-md italic break-words'>
      ${quote}
    </blockquote>`
  ),
  image: (href, _ignore, text) => (
    `<img src='${href}' alt='${text}' />`
  ),
};
